// store.js

import { createStore, combineReducers } from 'redux';
import blogReducer from './blog/blogReducer';
import portfolioReducer from './portfolio/portfolioReducer';
import careerReducer from './career/careerReducer';
import authReducer from './auth/authReducer';
import technologieReducer from './technologie/technologieReducer';
import newsReducer from './news/newsReducer';

// Combine reducers
const rootReducer = combineReducers({
  blog: blogReducer,
  portfolio: portfolioReducer,
  career :careerReducer,
  auth: authReducer,
  technologie: technologieReducer,
  news: newsReducer,
});

// Create Redux store with combined reducers
const store = createStore(rootReducer);

export default store;
